// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchAttributesSelect_wrapper__RjQma","select":"SearchAttributesSelect_select__2p1O0"};